'use client';

import styles from '../auto-insurance-matches.module.scss';
import type { MatchesFiltersProps } from './matches-filters';
import MatchesFiltersChip from './matches-filters-chip';

const MatchesFiltersChoices = ({
  filters,
  updateFilter,
}: MatchesFiltersProps) => {
  const { age, insurer, isMarried, isHomeOwner, isVeteran, addHomeInsurance } =
    filters;

  const choices = [
    age && `${age} in age`,
    insurer && `${insurer} in current insurance`,
    isMarried && 'married',
    isHomeOwner && 'homeowner',
    isVeteran && 'veteran',
    addHomeInsurance && 'addHomeInsurance',
  ].filter(Boolean) as string[];

  const handleDeleteChoice = (choice: string) => {
    const choiceMap: Record<string, keyof MatchesFiltersProps['filters']> = {
      'in age': 'age',
      'in current insurance': 'insurer',
      married: 'isMarried',
      homeowner: 'isHomeOwner',
      veteran: 'isVeteran',
      addHomeInsurance: 'addHomeInsurance',
    };

    const filterKey = Object.entries(choiceMap).find(([key]) =>
      choice.endsWith(key)
    )?.[1];

    if (filterKey) {
      updateFilter(
        filterKey,
        typeof filters[filterKey] === 'boolean' ? false : ''
      );
    }
  };

  return (
    choices.length > 0 && (
      <div className={styles.filtersChoicesContainer}>
        {choices.map((c) => (
          <MatchesFiltersChip
            key={c}
            label={c}
            onDelete={() => handleDeleteChoice(c)}
          />
        ))}
      </div>
    )
  );
};

export default MatchesFiltersChoices;
